import React from "react"
import { Modal, CardBody, Button, Card, Alert, Row, Col, Input, Label, FormGroup } from "reactstrap"
import NotificationAlert from "react-notification-alert"
import { connect } from "react-redux"
import readXlsxFile from "read-excel-file"
import moment from "moment"
import $ from "jquery"

class SmartExcelConverter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 1,
      rawData: [],
      headers: [],
      mappedData: [],
      columnMapping: {
        nome: "",
        sobrenome: "",
        nomeCompleto: "",
        email: "",
        usuario: "",
        dataNascimento: "",
        turma: "",
        tipoTurma: "",
        tipo: "",
        sexo: "",
        senha: "",
        nivelAcesso: ""
      },
      useFirstRowAsHeader: true,
      autoGenerateUsername: true,
      autoGeneratePassword: true,
      autoGenerateEmail: false,
      emailDomain: "@escola.com.br",
      defaultPassword: "123456",
      defaultAccessLevel: "",
      defaultTurma: "",
      defaultTipoTurma: "4",
      processedUsers: [],
      errors: [],
      importError: "",
      selectedUsers: new Set(),
      turmasComErro: [],
      showBulkClassChange: false,
      bulkNewClass: ""
    }
    
    this.processFile = this.processFile.bind(this)
    this.generateMappedData = this.generateMappedData.bind(this)
    this.downloadTemplate = this.downloadTemplate.bind(this)
    this.importDirectly = this.importDirectly.bind(this)
    this.reset = this.reset.bind(this)
    this.generateUsername = this.generateUsername.bind(this)
    this.splitName = this.splitName.bind(this)
    this.toggleUserSelection = this.toggleUserSelection.bind(this)
    this.selectAllWithSameError = this.selectAllWithSameError.bind(this)
    this.selectAllWithErrors = this.selectAllWithErrors.bind(this)
    this.clearSelection = this.clearSelection.bind(this)
    this.applyBulkClassChange = this.applyBulkClassChange.bind(this)
    this.changeUserClass = this.changeUserClass.bind(this)
  }

  reset() {
    this.setState({
      step: 1,
      rawData: [],
      headers: [],
      mappedData: [],
      columnMapping: {
        nome: "",
        sobrenome: "",
        nomeCompleto: "",
        email: "",
        usuario: "",
        dataNascimento: "",
        turma: "",
        tipoTurma: "",
        tipo: "",
        sexo: "",
        senha: "",
        nivelAcesso: ""
      },
      processedUsers: [],
      errors: [],
      importError: "",
      selectedUsers: new Set(),
      turmasComErro: [],
      showBulkClassChange: false,
      bulkNewClass: "",
      defaultTipoTurma: "4"
    })
  }

  splitName(fullName) {
    if (!fullName) return { name: "", lastName: "" }
    const parts = fullName.toString().trim().split(/\s+/)
    if (parts.length === 1) {
      return { name: parts[0], lastName: "" }
    }
    const name = parts[0]
    const lastName = parts.slice(1).join(" ")
    return { name, lastName }
  }

  generateUsername(fullName, index) {
    if (!fullName) return `usuario${index + 1}`
    
    let username = fullName
      .toString()
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s]/g, "")
      .replace(/\s+/g, ".")
    
    if (username.length > 50) {
      username = username.substring(0, 50)
    }
    
    if (username.length < 5) {
      username = username + (index + 1).toString().padStart(3, "0")
    }
    
    return username
  }

  generateEmail(username, domain) {
    return username + domain
  }

  detectGender(name) {
    if (!name) return ""
    const firstName = name.toString().trim().split(/\s+/)[0].toLowerCase()
    
    const maleEndings = ["o", "os", "r", "n", "l", "s", "z", "u"]
    const femaleEndings = ["a", "as", "e", "i", "y"]
    
    const maleNames = ["andre", "jose", "jorge", "rene", "dante", "vicente", "davi", "levi", "eli", "ari", "yuri", "rui"]
    const femaleNames = ["andrea", "josefa", "marta", "renata", "maria", "ana", "julia", "carla", "paula", "bruna", "carol", "nicole"]
    
    const normalizedName = firstName.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    
    if (femaleNames.includes(normalizedName)) return "1"
    if (maleNames.includes(normalizedName)) return "0"
    
    const lastChar = normalizedName.slice(-1)
    if (femaleEndings.includes(lastChar)) return "1"
    if (maleEndings.includes(lastChar)) return "0"
    
    return ""
  }

  processDate(dateValue) {
    if (!dateValue) return ""
    
    if (dateValue instanceof Date) {
      return moment(dateValue).format("DD/MM/YYYY")
    }
    
    const formats = [
      "DD/MM/YYYY", "DD-MM-YYYY", "YYYY-MM-DD",
      "MM/DD/YYYY", "DD/MM/YY", "D/M/YYYY", "D/M/YY"
    ]
    
    const parsed = moment(dateValue, formats, true)
    if (parsed.isValid()) {
      return parsed.format("DD/MM/YYYY")
    }
    
    if (typeof dateValue === "number") {
      const date = new Date((dateValue - 25569) * 86400 * 1000)
      return moment(date).format("DD/MM/YYYY")
    }
    
    return dateValue.toString()
  }

  toggleUserSelection(index) {
    const selected = new Set(this.state.selectedUsers)
    if (selected.has(index)) {
      selected.delete(index)
    } else {
      selected.add(index)
    }
    this.setState({ selectedUsers: selected })
  }

  selectAllWithSameError(turmaErro) {
    const selected = new Set(this.state.selectedUsers)
    this.state.processedUsers.forEach((user, i) => {
      if (user.turma === turmaErro && !user.turmaEncontrada) {
        selected.add(i)
      }
    })
    this.setState({ selectedUsers: selected })
  }

  selectAllWithErrors() {
    const selected = new Set()
    this.state.processedUsers.forEach((user, i) => {
      if (user.turma && !user.turmaEncontrada) {
        selected.add(i)
      }
    })
    this.setState({ selectedUsers: selected })
  }

  clearSelection() {
    this.setState({ selectedUsers: new Set() })
  }

  changeUserClass(userIndex, newClassId) {
    const user = this.state.processedUsers[userIndex]
    const oldTurma = user.turma
    const newClass = this.props.state?.classRoom?.find(c => c.id.toString() === newClassId)
    
    if (!newClass) return

    const applyToOthers = this.state.selectedUsers.size > 1 && this.state.selectedUsers.has(userIndex)
    
    if (applyToOthers) {
      const usersToUpdate = [...this.state.selectedUsers].filter(idx => {
        const u = this.state.processedUsers[idx]
        return u.turma === oldTurma && !u.turmaEncontrada
      })
      
      if (usersToUpdate.length > 1) {
        if (window.confirm(`Deseja aplicar esta turma para os outros ${usersToUpdate.length - 1} usuários selecionados com a mesma turma "${oldTurma}"?`)) {
          const updated = [...this.state.processedUsers]
          usersToUpdate.forEach(idx => {
            updated[idx] = {
              ...updated[idx],
              turmaEncontrada: newClass,
              turmaErro: ""
            }
          })
          this.updateProcessedUsersAndErrors(updated)
          return
        }
      }
    }
    
    const updated = [...this.state.processedUsers]
    updated[userIndex] = {
      ...updated[userIndex],
      turmaEncontrada: newClass,
      turmaErro: ""
    }
    this.updateProcessedUsersAndErrors(updated)
  }

  applyBulkClassChange() {
    const { bulkNewClass, selectedUsers, processedUsers } = this.state
    if (!bulkNewClass || selectedUsers.size === 0) return

    const newClass = this.props.state?.classRoom?.find(c => c.id.toString() === bulkNewClass)
    if (!newClass) return

    const updated = [...processedUsers]
    selectedUsers.forEach(idx => {
      updated[idx] = {
        ...updated[idx],
        turmaEncontrada: newClass,
        turmaErro: ""
      }
    })

    this.updateProcessedUsersAndErrors(updated)
    this.setState({ selectedUsers: new Set(), showBulkClassChange: false, bulkNewClass: "" })
  }

  updateProcessedUsersAndErrors(updated) {
    const errors = []
    const turmasComErro = new Set()
    
    updated.forEach((user, index) => {
      if (user.turma && !user.turmaEncontrada) {
        errors.push(`Linha ${user._linha}: Turma "${user.turma}" não encontrada no sistema`)
        turmasComErro.add(user.turma)
      }
    })

    this.setState({
      processedUsers: updated,
      errors,
      turmasComErro: [...turmasComErro]
    })
  }

  async processFile() {
    const input = document.getElementById("smart_input_xlsx")
    const file = input?.files?.[0]
    
    if (!file) {
      this.setState({ importError: "Selecione um arquivo Excel" })
      return
    }

    try {
      const rows = await readXlsxFile(file)
      
      if (!rows || rows.length === 0) {
        this.setState({ importError: "O arquivo está vazio" })
        return
      }

      const headers = this.state.useFirstRowAsHeader
        ? rows[0].map((h, i) => h?.toString() || `Coluna ${i + 1}`)
        : rows[0].map((_, i) => `Coluna ${i + 1}`)
      
      const data = this.state.useFirstRowAsHeader ? rows.slice(1) : rows

      const autoMapping = { ...this.state.columnMapping }
      headers.forEach((header, index) => {
        const h = header.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        if (h.includes("sobrenome") || h.includes("last")) {
          if (!autoMapping.sobrenome) autoMapping.sobrenome = index.toString()
        }
        if (h.includes("nome") && !h.includes("usuario") && !h.includes("sobrenome")) {
          if (h.includes("completo") || h.includes("full") || h.includes("nomecompleto")) {
            if (!autoMapping.nomeCompleto) autoMapping.nomeCompleto = index.toString()
          } else {
            if (!autoMapping.nome) autoMapping.nome = index.toString()
          }
        }
        if (h.includes("email") || h.includes("e-mail")) {
          autoMapping.email = index.toString()
        }
        if (h.includes("usuario") || h.includes("login") || h.includes("user")) {
          autoMapping.usuario = index.toString()
        }
        if (h.includes("nascimento") || h.includes("data") || h.includes("birth")) {
          autoMapping.dataNascimento = index.toString()
        }
        if (h.includes("turma") || h.includes("classe") || h.includes("class")) {
          if (h.includes("tipo") || h.includes("acesso") || h.includes("role")) {
            autoMapping.tipoTurma = index.toString()
          } else if (h.includes("cadastrar") || h.includes("nome") || !autoMapping.turma) {
            autoMapping.turma = index.toString()
          }
        }
        if ((h.includes("tipo") && (h.includes("turma") || h.includes("acesso"))) || h === "tipo") {
          if (!autoMapping.tipoTurma) autoMapping.tipoTurma = index.toString()
        }
        if (h.includes("sexo") || h.includes("genero") || h.includes("gender")) {
          autoMapping.sexo = index.toString()
        }
        if (h.includes("senha") || h.includes("password")) {
          autoMapping.senha = index.toString()
        }
        if (h.includes("tipo") && h.includes("turma")) {
          autoMapping.tipo = index.toString()
        }
        if ((h.includes("nivel") && h.includes("acesso")) || h === "acesso" || h.includes("perfil") || h.includes("role")) {
          autoMapping.nivelAcesso = index.toString()
        }
      })

      this.setState({
        rawData: data,
        headers,
        step: 2,
        columnMapping: autoMapping,
        importError: ""
      })
    } catch (error) {
      this.setState({ importError: "Erro ao ler o arquivo: " + error.message })
    }
  }

  generateMappedData() {
    const { rawData, columnMapping, autoGenerateUsername, autoGeneratePassword,
            autoGenerateEmail, emailDomain, defaultPassword, defaultAccessLevel } = this.state
    
    const processed = []
    const errors = []
    const usernameSet = new Set()
    const emailSet = new Set()
    const turmasComErro = new Set()

    rawData.forEach((row, index) => {
      try {
        let name = ""
        let lastName = ""

        if (columnMapping.nome !== "" || columnMapping.sobrenome !== "") {
          if (columnMapping.nome !== "") {
            name = row[parseInt(columnMapping.nome)]?.toString()?.trim() || ""
          }
          if (columnMapping.sobrenome !== "") {
            lastName = row[parseInt(columnMapping.sobrenome)]?.toString()?.trim() || ""
          }

          if ((name === "" || lastName === "") && columnMapping.nomeCompleto !== "") {
            const nc = row[parseInt(columnMapping.nomeCompleto)]?.toString()?.trim() || ""
            const parts = this.splitName(nc)
            if (name === "") name = parts.name
            if (lastName === "") lastName = parts.lastName
          }
        } else {
          const nomeCompleto = columnMapping.nomeCompleto !== ""
            ? row[parseInt(columnMapping.nomeCompleto)]?.toString()?.trim()
            : ""

          if (!nomeCompleto) {
            errors.push(`Linha ${index + 2}: Nome não encontrado`)
            return
          }

          const parts = this.splitName(nomeCompleto)
          name = parts.name
          lastName = parts.lastName
        }
        
        let username = columnMapping.usuario !== ""
          ? row[parseInt(columnMapping.usuario)]?.toString()?.trim()
          : ""
        
        if (!username && autoGenerateUsername) {
          const fullnameForUsername = (name + (lastName ? ` ${lastName}` : "")).trim()
          username = this.generateUsername(fullnameForUsername || name || lastName, index)
        }
        
        let originalUsername = username
        let counter = 1
        while (usernameSet.has(username)) {
          username = originalUsername + counter
          counter++
        }
        usernameSet.add(username)

        let email = columnMapping.email !== ""
          ? row[parseInt(columnMapping.email)]?.toString()?.trim()
          : ""
        
        if (!email && autoGenerateEmail) {
          email = this.generateEmail(username, emailDomain)
        }
        
        let originalEmail = email
        counter = 1
        while (emailSet.has(email)) {
          const parts = originalEmail.split("@")
          email = parts[0] + counter + "@" + (parts[1] || emailDomain.substring(1))
          counter++
        }
        emailSet.add(email)

        let birthDate = columnMapping.dataNascimento !== ""
          ? this.processDate(row[parseInt(columnMapping.dataNascimento)])
          : ""

        let genre = columnMapping.sexo !== ""
          ? row[parseInt(columnMapping.sexo)]?.toString()?.toLowerCase()?.trim()
          : ""
        
        if (!genre) {
          genre = this.detectGender(name)
        } else {
          const maleTerms = ["m", "masculino", "male", "homem", "0"]
          genre = maleTerms.includes(genre) ? "0" : "1"
        }

        let turma = columnMapping.turma !== ""
          ? row[parseInt(columnMapping.turma)]?.toString()?.trim()
          : this.state.defaultTurma

        let tipoTurma = ""
        if (columnMapping.tipoTurma !== "") {
          tipoTurma = row[parseInt(columnMapping.tipoTurma)]?.toString()?.trim() || ""
        } else if (columnMapping.tipo !== "") {
          tipoTurma = row[parseInt(columnMapping.tipo)]?.toString()?.trim() || ""
        }

        let turmaEncontrada = null
        let turmaErro = ""
        if (turma && this.props.state?.classRoom) {
          const normalize = s => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim()
          const target = normalize(turma)
          for (let c of this.props.state.classRoom) {
            const cname = normalize(c.name)
            let matched = false
            if (cname === target) matched = true
            else if (cname.includes(target) || target.includes(cname)) matched = true
            else if (cname.startsWith(target) || target.startsWith(cname)) matched = true
            if (matched) {
              turmaEncontrada = c
              break
            }
          }
          if (!turmaEncontrada) {
            turmaErro = `Turma "${turma}" não encontrada no sistema`
            errors.push(`Linha ${index + 2}: ${turmaErro}`)
            turmasComErro.add(turma)
          }
        }

        let tipoTurmaId = this.state.defaultTipoTurma || "4"
        if (tipoTurma && window.app?.state?.permitions) {
          const tipoLower = tipoTurma.toLowerCase()
          for (let p of window.app.state.permitions) {
            if ((p.name || "").toString().toLowerCase() === tipoLower) {
              tipoTurmaId = p.id.toString()
              break
            }
          }
        }
        if (!tipoTurmaId) tipoTurmaId = "4"

        let tipo = columnMapping.tipo !== ""
          ? row[parseInt(columnMapping.tipo)]?.toString()?.trim()
          : ""

        let password = columnMapping.senha !== ""
          ? row[parseInt(columnMapping.senha)]?.toString()?.trim()
          : ""
        
        if (!password && autoGeneratePassword) {
          password = defaultPassword
        }

        let accessLevel = defaultAccessLevel
        if (columnMapping.nivelAcesso !== "") {
          const nivelDaPlanilha = row[parseInt(columnMapping.nivelAcesso)]?.toString()?.trim() || ""
          if (nivelDaPlanilha) {
            const nivelLower = nivelDaPlanilha.toLowerCase()
            const levelFound = this.props.state?.levelAcess?.find(
              l => l.name.toLowerCase() === nivelLower
            )
            if (levelFound) {
              accessLevel = levelFound.id.toString()
            } else {
              const numId = parseInt(nivelDaPlanilha)
              if (!isNaN(numId)) {
                accessLevel = numId.toString()
              }
            }
          }
        }

        processed.push({
          name,
          lastName,
          email,
          username,
          genre,
          birthDate,
          accessLevel,
          blockedQRcode: "0",
          blocked: "0",
          password,
          turma,
          turmaEncontrada,
          turmaErro,
          tipoTurma,
          tipoTurmaId,
          tipo,
          _original: row,
          _linha: index + 2
        })
      } catch (err) {
        errors.push(`Linha ${index + 2}: Erro ao processar - ${err.message}`)
      }
    })

    this.setState({
      processedUsers: processed,
      errors,
      step: 3,
      turmasComErro: [...turmasComErro],
      selectedUsers: new Set()
    })
  }

  downloadTemplate() {
    const { processedUsers } = this.state
    
    const headers = ["Nome", "Sobrenome", "E-mail", "Usuário", "Sexo", "Data de Nascimento", "Tipo de Acesso", "Bloquear QR Code", "Bloquear Acesso", "Senha", "Turma", "Tipo na Turma"]
    
    const rows = processedUsers.map(user => [
      user.name,
      user.lastName,
      user.email,
      user.username,
      user.genre === "0" ? "Masculino" : "Feminino",
      user.birthDate,
      this.getAccessLevelName(user.accessLevel),
      user.blockedQRcode === "1" ? "Sim" : "Não",
      user.blocked === "1" ? "Sim" : "Não",
      user.password,
      user.turma || "",
      user.tipo || ""
    ])

    const escapeCsv = (val) => {
      if (val === null || val === undefined) return ""
      const str = val.toString()
      if (str.includes(",") || str.includes('"') || str.includes("\n")) {
        return `"${str.replace(/"/g, '""')}"`
      }
      return str
    }

    const csvContent = "\uFEFF" + [headers, ...rows]
      .map(row => row.map(escapeCsv).join(","))
      .join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.setAttribute("href", url)
    link.setAttribute("download", `importacao_usuarios_${moment().format("YYYYMMDD_HHmmss")}.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  getAccessLevelName(id) {
    const level = this.props.state?.levelAcess?.find(l => l.id.toString() === id.toString())
    return level?.name || id
  }

  async importDirectly() {
    const usersWithMissingClass = this.state.processedUsers.filter(u => u.turma && !u.turmaEncontrada)
    if (usersWithMissingClass.length > 0) {
      const missingClasses = [...new Set(usersWithMissingClass.map(u => u.turma))]
      if (!window.confirm(usersWithMissingClass.length + ' usuário(s) tem turmas não encontradas: ' + missingClasses.join(', ') + '. Continuar sem essas turmas?')) {
        return
      }
    }
    const formattedUsers = this.state.processedUsers.map(user => {
      const classRoomsCopy = JSON.parse(JSON.stringify(this.props.state?.classRoom || []))
      const userObj = {
        name: user.name,
        lastName: user.lastName,
        email: user.email,
        username: user.username,
        genre: user.genre,
        birthDate: user.birthDate,
        accessLevel: user.accessLevel,
        blockedQRcode: user.blockedQRcode,
        blocked: user.blocked,
        password: user.password,
        classRoom: [],
        classRooms: classRoomsCopy
      }
      if (user.turmaEncontrada) {
        const tipoId = user.tipoTurmaId || this.state.defaultTipoTurma || '4'
        const cls = { ...user.turmaEncontrada, type: tipoId }
        userObj.classRoom.push(cls)
        const idxInClassRooms = classRoomsCopy.findIndex(c => c.id.toString() === cls.id.toString())
        if (idxInClassRooms !== -1) {
          classRoomsCopy[idxInClassRooms].type = tipoId
        }
      }
      return userObj
    })
    if (window.importxlsx) {
      await window.importxlsx.setState({ usersList: formattedUsers, importError: '', verificado: false })
      this.props.onClose()
      window.importxlsx.checkXlsxServer()
    }
  }

  renderErrorClassPanel() {
    const { turmasComErro, selectedUsers, processedUsers, bulkNewClass } = this.state
    const usersWithErrors = processedUsers.filter(u => u.turma && !u.turmaEncontrada)
    
    if (usersWithErrors.length === 0) return null

    return (
      <Alert color="danger" className="mb-3">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            <strong>
              <i className="fas fa-exclamation-circle mr-2"></i>
              {usersWithErrors.length} usuário(s) com turmas não encontradas
            </strong>
          </div>
          <div>
            <Button size="sm" color="light" className="mr-2" onClick={this.selectAllWithErrors}>
              <i className="fas fa-check-double mr-1"></i>
              Selecionar Todos com Erro
            </Button>
            {selectedUsers.size > 0 && (
              <Button size="sm" color="light" onClick={this.clearSelection}>
                <i className="fas fa-times mr-1"></i>
                Limpar ({selectedUsers.size})
              </Button>
            )}
          </div>
        </div>

        <div className="mb-2">
          <small><strong>Turmas não encontradas:</strong></small>
          <div className="d-flex flex-wrap mt-1">
            {turmasComErro.map((turma, i) => {
              const count = processedUsers.filter(u => u.turma === turma && !u.turmaEncontrada).length
              return (
                <Button
                  key={i}
                  size="sm"
                  color="warning"
                  className="mr-2 mb-1"
                  onClick={() => this.selectAllWithSameError(turma)}
                  title={`Selecionar ${count} usuário(s) com esta turma`}
                >
                  {turma} ({count})
                </Button>
              )
            })}
          </div>
        </div>

        {selectedUsers.size > 0 && (
          <div className="mt-3 p-2 bg-white rounded">
            <Row className="align-items-center">
              <Col md={6}>
                <small className="text-muted">
                  <strong>{selectedUsers.size} usuário(s) selecionado(s)</strong> - Alterar turma para:
                </small>
              </Col>
              <Col md={4}>
                <Input
                  type="select"
                  bsSize="sm"
                  value={bulkNewClass}
                  onChange={e => this.setState({ bulkNewClass: e.target.value })}
                >
                  <option value="">Selecione a turma...</option>
                  {this.props.state?.classRoom?.map((c, i) => (
                    <option key={i} value={c.id}>{c.name}</option>
                  ))}
                </Input>
              </Col>
              <Col md={2}>
                <Button
                  size="sm"
                  color="success"
                  disabled={!bulkNewClass}
                  onClick={this.applyBulkClassChange}
                >
                  <i className="fas fa-check mr-1"></i>
                  Aplicar
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </Alert>
    )
  }

  render() {
    const { step, headers, columnMapping, processedUsers, importError, selectedUsers } = this.state

    return (
      <React.Fragment>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <Modal
          className="modal-dialog-centered"
          style={{ maxWidth: step >= 3 ? "95%" : "700px" }}
          isOpen={this.props.isOpen}
        >
          <div className="modal-body p-0">
            <Card className="bg-secondary border-0 mb-0">
              <div className="modal-header">
                <h6 className="modal-title">
                  <i className="fas fa-magic mr-2"></i>
                  Conversor Inteligente de Planilhas
                </h6>
                <button
                  aria-label="Close"
                  className="close"
                  type="button"
                  onClick={() => { this.reset(); this.props.onClose(); }}
                >
                  <span aria-hidden={true}>×</span>
                </button>
              </div>
              <CardBody>
                {importError && (
                  <Alert color="danger" className="animated tada">
                    <strong>Ops!</strong> {importError}
                  </Alert>
                )}

                {step === 1 && (
                  <div>
                    <p className="text-muted mb-3">
                      <strong>Passo 1:</strong> Envie qualquer planilha Excel com os dados dos alunos/funcionários.
                      O sistema irá identificar automaticamente as colunas e gerar a planilha no formato correto.
                    </p>
                    
                    <div className="custom-file mb-3">
                      <input
                        className="custom-file-input"
                        id="smart_input_xlsx"
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={() => {
                          const fileName = document.getElementById("smart_input_xlsx")?.files?.[0]?.name || "Selecionar arquivo"
                          $("label[for='smart_input_xlsx']").html(fileName)
                        }}
                      />
                      <label className="custom-file-label" htmlFor="smart_input_xlsx">
                        Selecionar arquivo Excel
                      </label>
                    </div>

                    <FormGroup check className="mb-3">
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={this.state.useFirstRowAsHeader}
                          onChange={e => this.setState({ useFirstRowAsHeader: e.target.checked })}
                        />{" "}
                        Primeira linha contém cabeçalhos
                      </Label>
                    </FormGroup>

                    <div className="text-center">
                      <Button color="primary" onClick={this.processFile}>
                        <i className="fas fa-upload mr-2"></i>
                        Processar Arquivo
                      </Button>
                    </div>
                  </div>
                )}

                {step === 2 && (
                  <div>
                    <p className="text-muted mb-3">
                      <strong>Passo 2:</strong> Informe qual coluna corresponde a cada campo.
                      Campos não encontrados serão gerados automaticamente.
                    </p>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label><strong>Nome (primeiro)</strong></Label>
                          <Input
                            type="select"
                            value={columnMapping.nome}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, nome: e.target.value }
                            })}
                          >
                            <option value="">Selecione...</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label><strong>Sobrenome</strong></Label>
                          <Input
                            type="select"
                            value={columnMapping.sobrenome}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, sobrenome: e.target.value }
                            })}
                          >
                            <option value="">Selecione...</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>E-mail</Label>
                          <Input
                            type="select"
                            value={columnMapping.email}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, email: e.target.value }
                            })}
                          >
                            <option value="">Gerar automaticamente</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Usuário/Login</Label>
                          <Input
                            type="select"
                            value={columnMapping.usuario}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, usuario: e.target.value }
                            })}
                          >
                            <option value="">Gerar automaticamente</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Data de Nascimento</Label>
                          <Input
                            type="select"
                            value={columnMapping.dataNascimento}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, dataNascimento: e.target.value }
                            })}
                          >
                            <option value="">Não informado</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}></Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Turma</Label>
                          <Input
                            type="select"
                            value={columnMapping.turma}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, turma: e.target.value }
                            })}
                          >
                            <option value="">Não informado</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Tipo de Acesso na Turma (Aluno, Professor...)</Label>
                          <Input
                            type="select"
                            value={columnMapping.tipoTurma}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, tipoTurma: e.target.value }
                            })}
                          >
                            <option value="">Usar padrão (definido abaixo)</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Sexo</Label>
                          <Input
                            type="select"
                            value={columnMapping.sexo}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, sexo: e.target.value }
                            })}
                          >
                            <option value="">Detectar pelo nome</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}></Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label><strong>Nível de Acesso</strong></Label>
                          <Input
                            type="select"
                            value={columnMapping.nivelAcesso}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, nivelAcesso: e.target.value }
                            })}
                          >
                            <option value="">Usar padrão (definido abaixo)</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Senha</Label>
                          <Input
                            type="select"
                            value={columnMapping.senha}
                            onChange={e => this.setState({
                              columnMapping: { ...columnMapping, senha: e.target.value }
                            })}
                          >
                            <option value="">Usar senha padrão</option>
                            {headers.map((h, i) => (
                              <option key={i} value={i}>{h}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <hr />

                    <h6>Configurações de Geração Automática</h6>
                    
                    <Row>
                      <Col md={6}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={this.state.autoGenerateUsername}
                              onChange={e => this.setState({ autoGenerateUsername: e.target.checked })}
                            />{" "}
                            Gerar usuário automaticamente (se não informado)
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={this.state.autoGenerateEmail}
                              onChange={e => this.setState({ autoGenerateEmail: e.target.checked })}
                            />{" "}
                            Gerar email automaticamente (se não informado)
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>

                    {this.state.autoGenerateEmail && (
                      <Row className="mt-2">
                        <Col md={6}>
                          <FormGroup>
                            <Label>Domínio do Email</Label>
                            <Input
                              type="text"
                              value={this.state.emailDomain}
                              onChange={e => this.setState({ emailDomain: e.target.value })}
                              placeholder="@escola.com.br"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    )}

                    <Row className="mt-2">
                      <Col md={6}>
                        <FormGroup>
                          <Label>Senha Padrão {columnMapping.senha !== "" && <small className="text-muted">(ignorado - usando coluna)</small>}</Label>
                          <Input
                            type="text"
                            value={this.state.defaultPassword}
                            onChange={e => this.setState({ defaultPassword: e.target.value })}
                            placeholder="123456"
                            disabled={columnMapping.senha !== ""}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>
                            Nível de Acesso Padrão
                            {columnMapping.nivelAcesso !== "" && <small className="text-muted"> (usado apenas se coluna vazia)</small>}
                          </Label>
                          <Input
                            type="select"
                            value={this.state.defaultAccessLevel}
                            onChange={e => this.setState({ defaultAccessLevel: e.target.value })}
                          >
                            <option value="">Selecione...</option>
                            {this.props.state?.levelAcess?.map((level, i) => (
                              <option key={i} value={level.id}>{level.name}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={6}>
                        <FormGroup>
                          <Label>
                            Tipo de Acesso na Turma Padrão
                            {columnMapping.tipoTurma !== "" && <small className="text-muted"> (usado apenas se coluna vazia)</small>}
                          </Label>
                          <Input
                            type="select"
                            value={this.state.defaultTipoTurma}
                            onChange={e => this.setState({ defaultTipoTurma: e.target.value })}
                          >
                            {window.app?.state?.permitions?.map((p, i) => (
                              <option key={i} value={p.id}>{p.name}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}></Col>
                    </Row>

                    <div className="text-center mt-3">
                      <Button color="secondary" className="mr-2" onClick={() => this.setState({ step: 1 })}>
                        <i className="fas fa-arrow-left mr-2"></i>
                        Voltar
                      </Button>
                      <Button
                        color="primary"
                        onClick={this.generateMappedData}
                        disabled={!((columnMapping.nome !== "" && columnMapping.sobrenome !== "") || columnMapping.nomeCompleto)}
                      >
                        <i className="fas fa-cogs mr-2"></i>
                        Processar Dados
                      </Button>
                    </div>
                  </div>
                )}

                {step === 3 && (
                  <div>
                    <p className="text-muted mb-3">
                      <strong>Passo 3:</strong> Revise os dados processados.
                      {processedUsers.length} usuários prontos para importar.
                    </p>

                    {this.renderErrorClassPanel()}

                    <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table className="table table-sm table-striped" style={{ tableLayout: "fixed" }}>
                        <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                          <tr>
                            <th style={{ width: "30px", textAlign: "center", verticalAlign: "middle" }}>
                              <input
                                type="checkbox"
                                checked={selectedUsers.size > 0 && selectedUsers.size === processedUsers.filter(u => u.turma && !u.turmaEncontrada).length}
                                onChange={() => {
                                  if (selectedUsers.size > 0) {
                                    this.clearSelection()
                                  } else {
                                    this.selectAllWithErrors()
                                  }
                                }}
                                style={{ cursor: "pointer" }}
                              />
                            </th>
                            <th style={{ width: "40px" }}>#</th>
                            <th style={{ width: "100px" }}>Nome</th>
                            <th style={{ width: "100px" }}>Sobrenome</th>
                            <th style={{ width: "150px" }}>Email</th>
                            <th style={{ width: "100px" }}>Usuário</th>
                            <th style={{ width: "40px" }}>Sexo</th>
                            <th style={{ width: "80px" }}>Nascimento</th>
                            <th style={{ width: "120px" }}>Turma</th>
                            <th style={{ width: "150px" }}>Corrigir Turma</th>
                            <th style={{ width: "80px" }}>Tipo na Turma</th>
                          </tr>
                        </thead>
                        <tbody>
                          {processedUsers.slice(0, 100).map((user, i) => (
                            <tr key={i} className={user.turmaErro ? "table-danger" : ""}>
                              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                {user.turma && !user.turmaEncontrada ? (
                                  <input
                                    type="checkbox"
                                    checked={selectedUsers.has(i)}
                                    onChange={() => this.toggleUserSelection(i)}
                                    style={{ cursor: "pointer" }}
                                  />
                                ) : null}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>{user._linha}</td>
                              <td style={{ verticalAlign: "middle", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.name}</td>
                              <td style={{ verticalAlign: "middle", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.lastName}</td>
                              <td style={{ verticalAlign: "middle", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.email}</td>
                              <td style={{ verticalAlign: "middle", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.username}</td>
                              <td style={{ verticalAlign: "middle", textAlign: "center" }}>{user.genre === "0" ? "M" : "F"}</td>
                              <td style={{ verticalAlign: "middle" }}>{user.birthDate}</td>
                              <td style={{ verticalAlign: "middle", maxWidth: "120px" }}>
                                {user.turmaEncontrada ? (
                                  <span
                                    className="text-success"
                                    style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: "pointer" }}
                                    title={user.turmaEncontrada.name}
                                    onClick={() => alert("Turma: " + user.turmaEncontrada.name)}
                                  >
                                    <i className="fas fa-check mr-1"></i>
                                    {user.turmaEncontrada.name}
                                  </span>
                                ) : user.turma ? (
                                  <span
                                    className="text-danger"
                                    style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: "pointer" }}
                                    title={user.turma + " (não encontrada)"}
                                    onClick={() => alert("Turma: " + user.turma + "\n\nEsta turma não foi encontrada no sistema.")}
                                  >
                                    <i className="fas fa-exclamation-triangle mr-1"></i>
                                    {user.turma}
                                  </span>
                                ) : "-"}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {user.turma && !user.turmaEncontrada && (
                                  <select
                                    className="form-control form-control-sm"
                                    value=""
                                    onChange={e => this.changeUserClass(i, e.target.value)}
                                    style={{ width: "100%", padding: "2px 4px", fontSize: "12px" }}
                                  >
                                    <option value="">Selecione...</option>
                                    {this.props.state?.classRoom?.map((c, idx) => (
                                      <option key={idx} value={c.id}>{c.name}</option>
                                    ))}
                                  </select>
                                )}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>{user.tipoTurma || "Aluno"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {processedUsers.length > 100 && (
                        <p className="text-muted text-center">
                          Mostrando 100 de {processedUsers.length} registros
                        </p>
                      )}
                    </div>

                    <div className="text-center mt-3">
                      <Button color="secondary" className="mr-2" onClick={() => this.setState({ step: 2 })}>
                        <i className="fas fa-arrow-left mr-2"></i>
                        Voltar
                      </Button>
                      <Button color="default" className="mr-2" onClick={this.downloadTemplate}>
                        <i className="fas fa-download mr-2"></i>
                        Baixar Planilha Formatada
                      </Button>
                      <Button color="success" onClick={this.importDirectly}>
                        <i className="fas fa-paper-plane mr-2"></i>
                        Enviar para Importação
                      </Button>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

export default connect(state => ({
  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user
}))(SmartExcelConverter)
